import { DndList } from '@design-system/components/dndList/DndList';
import { extrasVM } from '../Extras.page';
import { ExtrasItemRenderer } from './ExtrasItemRenderer';
import { _noop } from '@client/new/helpers/general';
import { Draggable } from '../viewModel/extras.types';
import { Alert } from '@design-system/components/alert/alert';

export const ExtrasContent = () => {
  const vm = extrasVM.useValue();

  console.log('ExtrasContent', vm);

  if (vm.contentIds.id === 'empty') return null;

  return (
    <div className="flex flex-col gap-4">
      <DndList
        items={(vm.contentIds.items || [])[0].items as Array<Draggable>}
        onChange={(d) => vm.dispatch('Reorder', d)}
        renderParent={ExtrasItemRenderer}
        renderChild={_noop}
      />
    </div>
  );
};
